import Component from "gia/Component";
import { AddToCart } from "../components/CartEvents.js";
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.form = this.DOM.view.querySelector('form[action$="/cart/add"]');
    this.DOM.btnAdd = this.ref.btnAdd[0];

    //
    this.events();
  }

  events() {
    this.DOM.btnAdd.addEventListener("click", () => {
      this.send();
    });
    Channels.addListener("addtocart::click", () => {
      this.send();
    });
  }

  send() {
    const data = new FormData(this.DOM.form);
    AddToCart(data, false);
  }

  unmount() {}
}
